import Hotjar from '@hotjar/browser';
import { CONSTANTS } from 'config/envVariables';

if ('HOTJAR_TRACKING_ID' in CONSTANTS) {
  Hotjar.init(CONSTANTS.HOTJAR_TRACKING_ID as number, 6);
}
